/**
 * WordPress dependencies
 */
import { SVG, Path } from '@wordpress/primitives';

const arrowRight = (
	<SVG xmlns="http://www.w3.org/2000/svg" viewBox="-2 -2 24 24">
		<Path d="M2 11V9h12l-4-4 1-2 7 7-7 7-1-2 4-4H2z" />
	</SVG>
);

export default arrowRight;
